import { MutationTypes } from "./mutation-types";
export const mutations = {
    [MutationTypes.ADD_TASK](state, payload) {
        state.tasks?.push(payload);
    },
};
